document.addEventListener('DOMContentLoaded', () => {
  // let animTl = gsap.timeline({ defaults: { ease: 'none' }, repeat: -1, repeatDelay: 1, paused: true });
  // let counterElement = document.getElementById('counter');
  // let counterValue = counterElement.getAttribute('data-counter');
  // let counterNumber = parseInt(counterValue, 10);

  // function tweenGS(number) {
  //   const digits = `${number}`.split('').reverse(); // Split and reverse the number into individual digits
  //   let maxTime = 3;
  //   animTl.add('p1');

  //   // Animate each digit
  //   digits.forEach((value, digitIndex) => {
  //     const digit = digitIndex + 1;
  //     const htmlDigit = document.getElementById(`n${digit}`);
  //     const numberPosition = value == 0 ? 150 : value * 15;

  //     const duration = maxTime + digitIndex * 0.2;

  //     animTl.to(htmlDigit, { y: `-${numberPosition}`, repeat: 1, duration: duration }, 'p1');
  //   });

  //   gsap.to(animTl, { progress: 1, ease: 'power3.inOut', duration: maxTime });
  // }

  // const observer = new IntersectionObserver(
  //   (entries, observer) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         tweenGS(counterNumber);
  //         observer.unobserve(entry.target);
  //       }
  //     });
  //   },
  //   {
  //     rootMargin: '0px 0px -50% 0px',
  //     threshold: 0,
  //   },
  // );
  // observer.observe(counterElement);
  // Configuration
  const initialDate = new Date('2024-01-12T00:00:00Z'); // Starting date
  const initialValue = 34320500; // Starting value in gallons
  const dailyIncrement = 23288; // Gallons per day
  const gallonsPerSecond = dailyIncrement / 86400; // Gallons per second

  const integerElement = document.querySelector('#waterMeter .integer');
  const decimalElement = document.querySelector('#waterMeter .decimal');

  function updateCounter() {
    const now = new Date();
    const elapsedSeconds = (now - initialDate) / 1000;
    const currentValue = initialValue + elapsedSeconds * gallonsPerSecond;

    // Format the number
    const formattedValue = currentValue.toFixed(2);
    const [integerPart, decimalPart] = formattedValue.split('.');

    // Update the counter elements
    integerElement.textContent = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    decimalElement.textContent = `.${decimalPart}`;
  }

  function animateCounter() {
    updateCounter();
    requestAnimationFrame(animateCounter);
  }

  // Start the animation
  animateCounter();
});
